export function getDefaultBuild() {
  if (import.meta.env.VITE_STAGING) {
    return 'staging';
  }

  if (import.meta.env.DEV) {
    return 'dev';
  }

  if (import.meta.env.PROD) {
    return 'prod';
  }

  return 'prod';
}

export const camelToSnakeCase = (str = '') => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const snakeCaseAttributes = ['encodedManifest'];

type FindOrParams<T> = {
  arr: T[];
  value: Nullish<string>;
  fallback: T;
};
export function findOr<T>({ arr, value, fallback }: FindOrParams<T>): T {
  return arr.find((v) => v === value) ?? fallback;
}

type DefaultTrueParams = {
  name: string;
  params: URLSearchParams;
};
export function booleanOrTrue({ name, params }: DefaultTrueParams) {
  const paramValue = params.get(name);
  if (!paramValue) {
    return true;
  }
  return paramValue === 'true';
}

type NumberOrParams = {
  params: URLSearchParams;
  name: string;
  fallback: number;
};
type NullishNumberOrParams = Omit<NumberOrParams, 'fallback'> & {
  fallback: null;
};

export function numberOr({ params, name, fallback }: NumberOrParams): number;
export function numberOr({ params, name, fallback }: NullishNumberOrParams): Nullish<number>;
export function numberOr({ params, name, fallback }: NumberOrParams | NullishNumberOrParams) {
  const value = params.get(name);
  if (!value) {
    return fallback;
  }
  const parsed = parseInt(value);
  return Number.isNaN(parsed) ? fallback : parsed;
}
